import script from "./CuDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CuDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CuDrawer.vue?vue&type=style&index=0&id=e376d372&lang=css"

const __exports__ = script;

export default __exports__